<template>
  <div :class="['filter-options', 'filter-' + scope]">
    <template v-if="mode != 'mini'">
      <h2 class="title title-2rd">筛选</h2>
    </template>
    <!-- 过滤条件：分类（递归树，任意层级均可展开/收起） -->
    <template v-if="filterOpts.category.items && filterOpts.category.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('category')">
          <span :class="['title', filterOpts.category.collapse ? '' : 'title-expand']">分类</span>
          <i class="iconfont">{{ filterOpts.category.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.category.collapse ? '' : 'active']">
          <ul class="item-list category-list">
            <category-node v-for="(node, i) in filterOpts.category.items" :key="i" :node="node" :level="0"
              :checked="filterOpts.category.checked" @toggle="toggleCategoryNode"
              @pick="toggleItem('category', $event)" />
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：系列（搜索 + 下拉列表） -->
    <template v-if="filterOpts.series.items && filterOpts.series.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('series')">
          <span :class="['title', filterOpts.series.collapse ? '' : 'title-expand']">系列</span>
          <i class="iconfont">{{ filterOpts.series.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper series-dropdown', filterOpts.series.collapse ? '' : 'active']">
          <!-- 单一外框容器：搜索行 + 滚动列表（样式对齐移动端 SeriesFilter） -->
          <div class="series-box">
            <!-- 搜索输入 -->
            <div class="series-search">
              <i class="iconfont-ot-website search-icon">&#xe690;</i>
              <input type="text" v-model="seriesSearchKw" placeholder="搜索" />
              <i v-if="seriesSearchKw" class="iconfont-ot-website close left-close-icon"
                @click="seriesSearchKw = ''">&#xe6df;</i>
            </div>
            <!-- 下拉列表：约 5 项高度，超出滚动（传值对齐移动端：series 传 value） -->
            <ul class="series-list">
              <li v-for="item in filteredSeriesItems" :key="String(item.id)"
                @click="toggleItem('series', item.value || item.id)">
                <i class="iconfont">{{ filterOpts.series.checked.indexOf(String(item.value || item.id)) != -1 ?
                  '&#xedaf;' : '&#xec58;' }}</i>
                <span class="series-name">{{ item.name }}</span>
                <span v-if="item.count != null && item.count != undefined" class="series-count">（{{ item.count
                }}）</span>
              </li>
              <li v-if="!filteredSeriesItems.length" class="series-empty">无匹配项</li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <!-- 过滤条件：颜色 -->
    <template v-if="filterOpts.colors.items && filterOpts.colors.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('colors')">
          <span :class="['title', filterOpts.colors.collapse ? '' : 'title-expand']">颜色</span>
          <i class="iconfont">{{ filterOpts.colors.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.colors.collapse ? '' : 'active']">
          <ul class="item-list color-list box clearfix">
            <li v-for="(item, i) in filterOpts.colors.items" :key="i"
              :class="[clsName(item.value), filterOpts.colors.checked.indexOf(String(item.name)) != -1 ? 'active' : '']"
              :style="{ 'background-color': item.value, }" @click="toggleItem('colors', item.name)" :title="item.name">
              <a />
              <img :src="`assets/ColorBlock/${item.value}.png` | ossPath" class="color-bg">
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：品牌（logo 图片） -->
    <template v-if="filterOpts.brand.items && filterOpts.brand.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('brand')">
          <span :class="['title', filterOpts.brand.collapse ? '' : 'title-expand']">品牌</span>
          <i class="iconfont">{{ filterOpts.brand.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.brand.collapse ? '' : 'active']">
          <ul class="item-list brand-list">
            <li v-for="(item, i) in filterOpts.brand.items" :key="i" @click="toggleItem('brand', item.id)">
              <i class="iconfont">{{ filterOpts.brand.checked.indexOf(String(item.id)) != -1 ? '&#xedaf;' :
                '&#xec58;' }}</i>
              <img v-if="item.logo" :src="item.logo" :alt="item.name" class="brand-logo" />
              <a v-else>{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：性别 -->
    <template v-if="filterOpts.genders.items && filterOpts.genders.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('genders')">
          <span :class="['title', filterOpts.genders.collapse ? '' : 'title-expand']">性别</span>
          <i class="iconfont">{{ filterOpts.genders.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.genders.collapse ? '' : 'active']">
          <ul class="item-list item-icon">
            <li v-for="(item, i) in filterOpts.genders.items" :key="i" @click="toggleItem('genders', item.id)">
              <i class="iconfont">{{ filterOpts.genders.checked.indexOf(String(item.id)) != -1 ?
                '&#xedaf;' : '&#xec58;' }}</i>
              <a>{{ item.name || item.value }}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：尺码 -->
    <template v-if="filterOpts.sizes.items && filterOpts.sizes.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('sizes')">
          <span :class="['title', filterOpts.sizes.collapse ? '' : 'title-expand']">尺码</span>
          <i class="iconfont">{{ filterOpts.sizes.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.sizes.collapse ? '' : 'active']">
          <ul class="item-list size-list box clearfix">
            <li v-for="(item, i) in filterOpts.sizes.items" :key="i"
              :class="[filterOpts.sizes.checked.indexOf(String(item.id)) != -1 ? 'active' : '']"
              @click="toggleItem('sizes', item.id)">
              <a>{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：衣长 -->
    <template v-if="filterOpts.clothingLength.items && filterOpts.clothingLength.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('clothingLength')">
          <span :class="['title', filterOpts.clothingLength.collapse ? '' : 'title-expand']">衣长</span>
          <i class="iconfont">{{ filterOpts.clothingLength.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.clothingLength.collapse ? '' : 'active']">
          <ul class="item-list item-icon">
            <li v-for="(item, i) in filterOpts.clothingLength.items" :key="i"
              @click="toggleItem('clothingLength', item.id)">
              <i class="iconfont">{{ filterOpts.clothingLength.checked.indexOf(String(item.id)) != -1 ? '&#xedaf;' :
                '&#xec58;' }}</i>
              <a>{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：袖长 -->
    <template v-if="filterOpts.sleeveLength.items && filterOpts.sleeveLength.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('sleeveLength')">
          <span :class="['title', filterOpts.sleeveLength.collapse ? '' : 'title-expand']">袖长</span>
          <i class="iconfont">{{ filterOpts.sleeveLength.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.sleeveLength.collapse ? '' : 'active']">
          <ul class="item-list item-icon">
            <li v-for="(item, i) in filterOpts.sleeveLength.items" :key="i"
              @click="toggleItem('sleeveLength', item.id)">
              <i class="iconfont">{{ filterOpts.sleeveLength.checked.indexOf(String(item.id)) != -1 ? '&#xedaf;' :
                '&#xec58;' }}</i>
              <a>{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：尺寸 -->
    <template v-if="filterOpts.measurements.items && filterOpts.measurements.items.length">
      <div class="filter-item">
        <a class="item-header" @click="toggle('measurements')">
          <span :class="['title', filterOpts.measurements.collapse ? '' : 'title-expand']">尺寸</span>
          <i class="iconfont">{{ filterOpts.measurements.collapse ? '&#xe61e;' : '&#xe613;' }}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.measurements.collapse ? '' : 'active']">
          <ul class="item-list item-icon">
            <li v-for="(item, i) in filterOpts.measurements.items" :key="i"
              @click="toggleItem('measurements', item.id)">
              <i class="iconfont">{{ filterOpts.measurements.checked.indexOf(String(item.id)) != -1 ? '&#xedaf;' :
                '&#xec58;' }}</i>
              <a>{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CategoryNode from '@/components/CategoryNode.vue';
// 勾选与系列搜索逻辑抽取为共享 mixin（与移动端筛选抽屉保持一致）
import filterOptionMixin from '@/mixins/filterOption';
export default {
  name: 'ListFilter',
  components: { CategoryNode },
  mixins: [filterOptionMixin],
  props: {
    // 使用此组件的作用域: category(类目页) / search(搜索页), 因请求接口不同用此字段作区分
    scope: String,
    filterOpts: Object,
    mode: String,
    title: String
  },
  methods: {
    toggle(opt) {
      this.filterOpts[opt].collapse = !this.filterOpts[opt].collapse;
    },
    // 分类：任意层级分组节点展开/收起（_collapse 在 fillFilters 赋值前已初始化，是响应式属性）
    toggleCategoryNode(node) {
      if (node && node.children && node.children.length) {
        node._collapse = !node._collapse;
      }
    },
    clsName(cls) {
      if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(cls)) {
        cls = cls.replace('#', '').toUpperCase();
        if (cls == 'FFFFFF' || cls == 'FFF') {
          cls = 'white'; // like-white
        } else {
          cls = `cls-${cls}`;
        }
      }
      return cls;
    }
  }
};
</script>

<style lang="scss" scoped>
i.iconfont {
  color: black;
}

.filter-options {
  .title {
    line-height: calc(1.3125rem * 1.6);
    font-weight: 400;
    font-size: calc(.875rem * 1.6);
    letter-spacing: .05em;
    display: block;
    position: relative;
    margin: 0;
    padding: 15px 0;
    color: #000;
    cursor: pointer;
    text-align: left;

    &.title-2rd {
      border-bottom: 1px solid #b4b5b4;
      font-size: calc(1.5rem * 1.6);
    }
  }

  &>.title {
    font-size: calc(2rem * 1.6);
    line-height: normal;
    font-weight: 400;
    padding: 16px 0 10px;
  }

  .filter-item {
    position: relative;
    border-bottom: 1px solid #b4b5b4;
    border-width: thin;
    cursor: pointer;

    .item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        display: inline-block;
        font-weight: 400;

        &.title-expand {
          padding-bottom: 8px;
        }
      }

      // &:hover {
      //   font-weight: 400;
      //   color: #BABEC2;

      //   span {
      //     text-decoration: underline;
      //     color: #BABEC2;
      //   }

      //   .iconfont {
      //     text-decoration: none;
      //   }
      // }
    }

    .item-list-wrapper {
      display: none;

      &.active {
        display: block;
      }

      .item-list {
        padding: 0 0 30px;

        li {
          text-align: left;
          line-height: 30px;
          font-size: .875rem;
          display: flex;
          align-items: center;

          a {
            font-size: 12px;
            letter-spacing: .025em;
            overflow: hidden;
            color: #666;
            text-decoration: none;
          }
        }

        &.active {
          display: block;
        }

        &.box {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -5px;

          li {
            width: 40px;
            height: 35px;
            padding: 0;
            border: 1px solid #b4b5b4;
            border-radius: .5em;
            margin: 3px;
            display: flex;
            align-items: center;
            overflow: hidden;

            a {
              width: 100%;
              padding: 0;
              text-align: center;
              color: #000;
              border-radius: .5em;
              position: relative;
            }

            &.active {
              a {
                color: #FFF;
              }
            }
          }
        }

        &.item-icon {
          li a {
            margin-left: 2px;
          }
        }

        &.size-list {
          li a:hover {
            font-weight: 400;
            color: #BABEC2;
          }

          li.active {
            background-color: #4d4d4c;
          }
        }

        &.color-list {
          li {
            position: relative;

            .color-bg {
              content: "";
              position: absolute;
              display: block;
              width: 100%;
              height: 100%;
            }

            a {
              height: 35px;
            }

            &.active {
              a::after {
                content: "";
                position: absolute;
                z-index: 1;
                display: block;
                width: 4px;
                height: 9px;
                border: solid #fff;
                border-width: 0 2px 2px 0;
                left: 50%;
                top: 50%;
                -webkit-transform: translate(-50%, -60%) rotate(45deg);
                -ms-transform: translate(-50%, -60%) rotate(45deg);
                transform: translate(-50%, -60%) rotate(45deg);
              }
            }

            &.active.white,
            &.active.like-white {
              a::after {
                border: solid #000;
                border-width: 0 2px 2px 0;
              }
            }
          }
        }

        // 分类（递归树）：覆盖通用 li 样式
        &.category-list {
          padding: 0 0 30px 12px;

          ::v-deep .cat-node {
            line-height: 24px;
            font-size: 12px;
            font-weight: 400;
          }
        }

        // 品牌（logo）
        &.brand-list {
          padding: 0 0 30px;

          li {
            padding: 5px 0;
            line-height: 1;
            min-height: 36px;
            max-height: 36px;

            .brand-logo {
              // 高度 12px~36px 区间自适应
              height: auto;
              min-height: 12px;
              max-height: 36px;
              width: auto;
              object-fit: cover;
              margin-left: 6px;
              display: block;
            }
          }
        }
      }

      // 系列（搜索框 + 5 项滚动下拉）：单一外框，搜索行与列表用分隔线隔开（尺寸对齐移动端 SeriesFilter）
      // 注意：series-dropdown 类挂在 item-list-wrapper 元素上，必须与此同级，嵌套进 .item-list 会匹配不到
      &.series-dropdown {
        padding: 0 0 30px;

        .series-box {
          border: 1px solid #b4b5b4;
          padding: 0 0 10px;
        }

        .series-search {
          position: relative;
          display: flex;
          align-items: center;
          height: 36px;
          border-bottom: 1px solid #BABEC2;
          padding: 0 10px;
          margin-bottom: 10px;

          .search-icon {
            font-size: 24px;
            margin-right: 6px;
            color: #BABEC2;
          }

          input {
            flex: 1;
            border: none;
            outline: none;
            height: 100%;
            font-size: 14px;
            background: transparent;
            color: #000;
            padding: 0;

            &::placeholder {
              color: #BABEC2;
              font-size: 14px;
            }
          }

          .series-clear {
            cursor: pointer;
            font-size: 20px;
            line-height: 1;
            color: #BABEC2;
            padding: 0 2px;
            text-decoration: none;

            &:hover {
              color: #666;
            }
          }
        }

        .series-list {
          max-height: 170px;
          overflow-y: auto;

          li {
            cursor: pointer;
            display: flex;
            align-items: flex-start;
            padding: 7px 10px;

            .iconfont {
              margin-right: 8px;
              flex-shrink: 0;
              line-height: 1.3
            }

            .series-name {
              font-size: 14px;
              color: #333;
              text-decoration: none;
              line-height: 20px;
              text-align: left;
            }

            .series-count {
              font-size: 12px;
              color: #BABEC2;
              margin-left: 4px;
              white-space: nowrap;
            }
          }

          .series-empty {
            font-size: 12px;
            color: #BABEC2;
            text-align: center;
            padding: 16px 0;
            justify-content: center;
            width: 100%;
            cursor: default;
          }

          // 自定义滚动条
          &::-webkit-scrollbar {
            width: 8px;
          }

          &::-webkit-scrollbar-track {
            background: #f5f5f5;
          }

          &::-webkit-scrollbar-thumb {
            background: #4d4d4c;
            border-radius: 4px;
          }
        }
      }
    }
  }

  &.filter-search {
    &>.title-1st {
      display: none;
    }
  }
}
</style>
